/* ROOMS · пташка у футері (snippets/rooms-logo-pet.liquid з modifier 'footer', стилі в assets/custom.css).
   Поки футер на екрані, раз на 5–11 секунд пташка проявляється в повітрі або залітає з краю, пролітає дугою
   через футер і сідає на літеру R, O чи S логотипа або на лінію поля e-mail, як на дріт. Посидівши 2–4 секунди,
   злітає і розчиняється в повітрі. Іноді просто перетинає футер без зупинки. Маршрути будуються щоразу заново
   в пікселях футера; приліт закінчується, а відліт починається рухом угору, тож сидить вона головою догори. */
(function () {
  var foot = document.querySelector('[data-rooms-footer]');
  var pet = foot && foot.querySelector('.rooms-pet--footer');
  if (!pet) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!(window.CSS && CSS.supports && CSS.supports('offset-path', 'path("M0 0L1 1")'))) return;

  var sky = pet.parentNode;
  var SPEED = 240; /* px за секунду */
  var CLASS = 'rooms-pet rooms-pet--footer';
  var state = 'hidden', timer = null, onScreen = false, lastPerch = '';
  var meter = document.createElementNS('http://www.w3.org/2000/svg', 'path');

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(list) { return list[Math.floor(Math.random() * list.length)]; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function n(v) { return v.toFixed(1); }

  function length(d) {
    meter.setAttribute('d', d);
    try { return meter.getTotalLength(); } catch (e) { return 900; }
  }

  /* крива через точки; дотичні всередині як у Catmull-Rom, на кінцях задані */
  function curve(pts, t0, t1) {
    var d = 'M' + n(pts[0].x) + ' ' + n(pts[0].y);
    for (var i = 0; i < pts.length - 1; i++) {
      var a = pts[i], b = pts[i + 1];
      var ta = i === 0 ? t0 : { x: (b.x - pts[i - 1].x) / 2, y: (b.y - pts[i - 1].y) / 2 };
      var tb = i + 2 === pts.length ? t1 : { x: (pts[i + 2].x - a.x) / 2, y: (pts[i + 2].y - a.y) / 2 };
      d += ' C' + n(a.x + ta.x / 3) + ' ' + n(a.y + ta.y / 3) + ' ' + n(b.x - tb.x / 3) + ' ' + n(b.y - tb.y / 3) + ' ' + n(b.x) + ' ' + n(b.y);
    }
    return d;
  }

  function toward(a, b, k) {
    return { x: (b.x - a.x) * k, y: (b.y - a.y) * k };
  }

  /* де можна сісти: верх літер логотипа (R, O, S на 7, 50 і 93% ширини, як у шапці) і лінія поля e-mail */
  function perches(size) {
    var box = sky.getBoundingClientRect(), out = [];
    var logo = foot.querySelector('.footer__image img');
    if (logo && logo.offsetWidth) {
      var r = logo.getBoundingClientRect();
      [['R', 0.07], ['O', 0.5], ['S', 0.93]].forEach(function (l) {
        out.push({ id: l[0], x: r.left - box.left + r.width * l[1], y: r.top - box.top + r.width * 0.04 - size * 0.4 });
      });
    }
    var input = foot.querySelector('.footer__newsletter input[type="email"]');
    if (input && input.offsetWidth > 220) {
      var q = input.getBoundingClientRect();
      out.push({ id: 'wire', x: q.left - box.left + rnd(q.width * 0.12, q.width - 170), y: q.bottom - box.top - 1 - size * 0.4 });
    }
    return out.filter(function (p) { return p.id !== lastPerch; });
  }

  /* звідки: з-за лівого, правого чи верхнього краю, або просто з повітря */
  function startPoint(W, H) {
    var side = pick(['left', 'right', 'top', 'air', 'air']);
    if (side === 'left') return { x: -30, y: rnd(0.08, 0.55) * H };
    if (side === 'right') return { x: W + 30, y: rnd(0.08, 0.55) * H };
    if (side === 'top') return { x: rnd(0.1, 0.9) * W, y: -30 };
    return { x: rnd(0.08, 0.92) * W, y: rnd(0.06, 0.45) * H };
  }

  /* точка в повітрі, через яку пролягає дуга: подалі від початку й від мети */
  function waypoint(W, H, from, to) {
    var best = null, score = -1;
    for (var i = 0; i < 8; i++) {
      var p = { x: rnd(0.08, 0.92) * W, y: rnd(0.08, 0.7) * H };
      var s = Math.min(Math.hypot(p.x - from.x, p.y - from.y), Math.hypot(p.x - to.x, p.y - to.y) * 1.4);
      if (s > score) { score = s; best = p; }
    }
    return best;
  }

  function setClass(name, seconds) {
    if (seconds) pet.style.setProperty('--rooms-pet-t', seconds.toFixed(2) + 's');
    pet.className = CLASS + (name ? ' ' + name : '');
  }

  function rest() {
    state = 'hidden';
    setClass('');
    schedule(rnd(5000, 11000));
  }

  /* проліт без зупинки */
  function pass(W, H) {
    var s = startPoint(W, H), e = startPoint(W, H);
    var a = waypoint(W, H, s, e), b = waypoint(W, H, a, e);
    var d = curve([s, a, b, e], toward(s, a, 1), toward(b, e, 1));
    var t = clamp(length(d) / SPEED, 5, 10);
    pet.style.setProperty('--rooms-pet-out', 'path("' + d + '")');
    state = 'pass';
    setClass('is-pass', t);
    setTimeout(rest, t * 1000);
  }

  function visit() {
    if (state !== 'hidden' || !onScreen || document.hidden) return;
    var W = sky.offsetWidth, H = sky.offsetHeight;
    if (W < 300 || H < 200) return;
    var size = W < 760 ? 22 : 26;
    pet.style.setProperty('--rooms-pet-size', size + 'px');

    var spots = perches(size);
    if (!spots.length || Math.random() < 0.25) return pass(W, H);

    var p = pick(spots);
    lastPerch = p.id;
    var s = startPoint(W, H), a = waypoint(W, H, s, p);
    var inn = curve([s, a, p], toward(s, a, 1), { x: 0, y: -150 });

    /* відліт: угору, дугою вбік і далі, розчиняючись */
    var dir = p.x < W / 2 ? 1 : -1;
    if (Math.random() < 0.3) dir = -dir;
    var c = { x: p.x + dir * rnd(140, 320), y: Math.max(p.y - rnd(90, 200), 0.05 * H) };
    var e = { x: c.x + dir * rnd(220, 480), y: c.y - rnd(40, 160) };
    var out = curve([p, c, e], { x: 0, y: -160 }, toward(c, e, 1));

    pet.style.setProperty('--rooms-pet-in', 'path("' + inn + '")');
    pet.style.setProperty('--rooms-pet-out', 'path("' + out + '")');

    var tIn = clamp(length(inn) / SPEED, 2.8, 7.5);
    var tOut = clamp(length(out) / SPEED, 2.2, 4.5);
    state = 'in';
    setClass('is-in', tIn);
    setTimeout(function () {
      state = 'sit';
      setClass('is-sit');
      setTimeout(function () {
        state = 'out';
        setClass('is-out', tOut);
        setTimeout(rest, tOut * 1000);
      }, rnd(2000, 4000));
    }, tIn * 1000);
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = null;
    if (!onScreen) return;
    timer = setTimeout(function () { timer = null; visit(); if (state === 'hidden') schedule(rnd(5000, 11000)); }, ms);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      if (onScreen && state === 'hidden' && !timer) schedule(900);
      if (!onScreen) { clearTimeout(timer); timer = null; }
    }, { threshold: 0.2 }).observe(foot);
  } else {
    onScreen = true;
    schedule(1500);
  }

  var logoLink = foot.querySelector('.footer__image');
  if (logoLink) logoLink.addEventListener('mouseenter', function () { if (state === 'hidden') visit(); });
})();
